.pill {
  display: inline-block;
  border-radius: var(--co-radius-s);
  padding: 3px 8px;
  font-size: var(--co-size-badge);
  font-weight: 700;
  letter-spacing: 0.2px;
  white-space: nowrap;
}

.mono {
  font-family: var(--co-mono);
}

.ready {
  background: var(--co-success-subtle);
  color: var(--co-success-text);
}

.clar {
  background: var(--co-warning-subtle);
  color: var(--co-warning-text);
}

.conf {
  background: var(--co-danger-subtle);
  color: var(--co-danger-text);
}

.manual {
  background: var(--co-violet-subtle);
  color: var(--co-violet-text);
}

.unsafe {
  background: var(--co-surface-subtle);
  color: var(--co-ui-extra-strong);
}

.signed {
  background: var(--co-magenta-subtle);
  color: var(--co-magenta);
}

.ai {
  background: var(--co-info-subtle);
  color: var(--co-info-text);
}

.neutral {
  background: var(--co-surface-subtle);
  color: var(--co-ui-extra-strong);
}
